import React, { useState } from "react";
import * as S from "./styled";
import HeaderLogo from "../../../assets/images/header/header-logo.png";
import { NavLink, useLocation } from "react-router-dom";
import Icon from "../../Icon";

const Header = () => {
  const { pathname } = useLocation();

  const [isSubNavOpen, setIsSubNavOpen] = useState(false);

  const [isMobNavOpen, setIsMobNavOpen] = useState<boolean>(false);

  return (
    <>
      <S.HeaderComponent
        className="main-header"
        onMouseEnter={() => setIsSubNavOpen(true)}
        onMouseLeave={() => setIsSubNavOpen(false)}
      >
        <div className="inner">
          <S.HeaderContainer>
            <NavLink to="/">
              <S.HeaderLogo className="header-logo">
                <Icon>
                  <img src={HeaderLogo} alt="logo" />
                </Icon>
              </S.HeaderLogo>
            </NavLink>
            <S.HeaderNav>
              <ul>
                <li
                  className={`${
                    pathname === "/aboutus" ||
                    pathname === "/history" ||
                    pathname === "/organization" ||
                    pathname === "/info"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink to="/aboutus">협회 소개</NavLink>
                </li>
                <li
                  className={`${
                    pathname === "/education" || pathname === "/qualifications"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink
                    to="/education
"
                  >
                    자격 검정 안내
                  </NavLink>
                </li>
                <li
                  className={`${
                    pathname === "/board" || pathname === "/notice"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink to="/board">협회 소식</NavLink>
                </li>
              </ul>
            </S.HeaderNav>
            <S.HeaderSubNav isOpen={isSubNavOpen}>
              <ul>
                <li>
                  <ul>
                    <li
                      className={`${pathname === "/aboutus" ? "active" : ""}`}
                    >
                      <NavLink to="/aboutus">인사말</NavLink>
                    </li>
                    <li
                      className={`${pathname === "/history" ? "active" : ""}`}
                    >
                      <NavLink to="/history">협회 연혁</NavLink>
                    </li>
                    <li
                      className={`${
                        pathname === "/organization" ? "active" : ""
                      }`}
                    >
                      <NavLink to="/organization">협회 조직도</NavLink>
                    </li>
                    <li className={`${pathname === "/info" ? "active" : ""}`}>
                      <NavLink to="/info">협회 지부 안내</NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <ul>
                    <li
                      className={`${pathname === "/education" ? "active" : ""}`}
                    >
                      <NavLink to="/education">교육 안내</NavLink>
                    </li>
                    <li
                      className={`${
                        pathname === "/qualifications" ? "active" : ""
                      }`}
                    >
                      <NavLink to="/qualifications">
                        셔플댄스 지도자 자격증
                      </NavLink>
                    </li>
                    <li className={`${pathname === "/kpop" ? "active" : ""}`}>
                      <NavLink to="/kpop">KPOP 지도자 자격증</NavLink>
                    </li>
                  </ul>
                </li>
                <li>
                  <ul>
                    <li className={`${pathname === "/board" ? "active" : ""}`}>
                      <NavLink to="/board">협회 활동</NavLink>
                    </li>
                    <li className={`${pathname === "/notice" ? "active" : ""}`}>
                      <NavLink to="/notice">공지사항</NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </S.HeaderSubNav>
          </S.HeaderContainer>
        </div>
      </S.HeaderComponent>

      <S.HeaderMobComponent>
        <div className="inner">
          <S.HeaderMobContainer>
            <NavLink to="/">
              <S.HeaderLogo className="header-logo">
                <Icon>
                  <img src={HeaderLogo} alt="logo" />
                </Icon>
              </S.HeaderLogo>
            </NavLink>

            {/* S ::: Mobile ::: S */}
            <S.HeaderHamBugerWrap
              onClick={() => setIsMobNavOpen((prev) => !prev)}
              className={isMobNavOpen ? "active" : ""}
            >
              <span></span>
              <span></span>
              <span></span>
            </S.HeaderHamBugerWrap>
            {/* E ::: Mobile ::: E */}
          </S.HeaderMobContainer>
        </div>

        {/* S ::: Mobile ::: S */}
        <S.HeaderMobNavDim
          className={isMobNavOpen ? "active" : ""}
          onClick={() => setIsMobNavOpen((prev) => !prev)}
        />
        <S.HeaderMobNavWrap className={isMobNavOpen ? "active" : ""}>
          <S.HeaderMobNavContentsWrap>
            <S.HeaderMobLogo>
              <Icon>
                <img src={HeaderLogo} alt="logo" />
              </Icon>
            </S.HeaderMobLogo>
            <S.HeaderMobNav>
              <ul>
                <li
                  className={`${
                    pathname === "/aboutus" ||
                    pathname === "/history" ||
                    pathname === "/organization" ||
                    pathname === "/info"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink to="/aboutus" onClick={() => setIsMobNavOpen(false)}>
                    협회 소개
                  </NavLink>
                  <ul>
                    <li
                      className={`${pathname === "/aboutus" ? "active" : ""}`}
                    >
                      <NavLink
                        to="/aboutus"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        인사말
                      </NavLink>
                    </li>
                    <li
                      className={`${pathname === "/history" ? "active" : ""}`}
                    >
                      <NavLink
                        to="/history"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        협회 연혁
                      </NavLink>
                    </li>
                    <li
                      className={`${
                        pathname === "/organization" ? "active" : ""
                      }`}
                    >
                      <NavLink
                        to="/organization"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        협회 조직도
                      </NavLink>
                    </li>
                    <li className={`${pathname === "/info" ? "active" : ""}`}>
                      <NavLink
                        to="/info"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        협회 지부 안내
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li
                  className={`${
                    pathname === "/education" || pathname === "/qualifications"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink
                    to="/education
"
                    onClick={() => setIsMobNavOpen(false)}
                  >
                    자격 검정 안내
                  </NavLink>
                  <ul>
                    <li
                      className={`${pathname === "/education" ? "active" : ""}`}
                    >
                      <NavLink
                        to="/education"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        교육 안내
                      </NavLink>
                    </li>
                    <li
                      className={`${
                        pathname === "/qualifications" ? "active" : ""
                      }`}
                    >
                      <NavLink
                        to="/qualifications"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        셔플댄스 지도자 자격증
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li
                  className={`${
                    pathname === "/board" || pathname === "/notice"
                      ? "active"
                      : ""
                  }`}
                >
                  <NavLink to="/board" onClick={() => setIsMobNavOpen(false)}>
                    협회 소식
                  </NavLink>
                  <ul>
                    <li className={`${pathname === "/board" ? "active" : ""}`}>
                      <NavLink
                        to="/board"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        협회 활동
                      </NavLink>
                    </li>
                    <li className={`${pathname === "/notice" ? "active" : ""}`}>
                      <NavLink
                        to="/notice"
                        onClick={() => setIsMobNavOpen(false)}
                      >
                        공지사항
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </S.HeaderMobNav>
          </S.HeaderMobNavContentsWrap>
        </S.HeaderMobNavWrap>
        {/* E ::: Mobile ::: E */}
      </S.HeaderMobComponent>
    </>
  );
};

export default Header;
